module.exports = __webpack_public_path__ + "static/media/retirement-object-0-1-0.569bf9a0.png";